module.exports = __webpack_public_path__ + "img/price-icon2.4c269bfd.png";